import { createSelector } from 'reselect';
import appSelector from './appSelector';

export default createSelector(
    appSelector,
    ({ location = {} }) => {
        const { host, protocol, baseUrl } = location;
        return `${protocol}://${host}${baseUrl}`;
    }
);



// WEBPACK FOOTER //
// ./app/common/selectors/appBaseUrlSelector.js